import { ref } from 'vue';

export const cmsMediaSavingCount = ref(0);

export function beginCmsMediaSaving(): void {
  cmsMediaSavingCount.value += 1;
  if (cmsMediaSavingCount.value === 1) {
    document.body.classList.add('cms-media-saving');
  }
}

export function endCmsMediaSaving(): void {
  cmsMediaSavingCount.value = Math.max(0, cmsMediaSavingCount.value - 1);
  if (cmsMediaSavingCount.value === 0) {
    document.body.classList.remove('cms-media-saving');
  }
}

export async function withCmsMediaSaving<T>(fn: () => Promise<T>): Promise<T> {
  beginCmsMediaSaving();
  try {
    return await fn();
  } finally {
    endCmsMediaSaving();
  }
}
